import { USALandingOptions } from "./USALandingOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate12: LandingPageConfigOptions = {
  consentAge: 18,
  ...USALandingOptions,
};
